import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, GFunc, LocaleX, ReqX, ZString } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, Spacer, VStack, XButton, XImage, XText } from "IZOX/_X";
import PAContainer from "../shared/PAContainer/PAContainer";
import { QFText } from "IZOX/BLOCKS/Libs/QForm/_gears";
import { PageFlipper, QForm } from "IZOX/BLOCKS/Libs";
import QUICKUI from "shared/QUICKUI";
import _ from "lodash";
import NewClient from "./_gears/NewClient";
import ViewClient from "./_gears/ViewClient";

/**
 * @augments {Component<Props, State>}
 */
class PAClientManageM extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {
      docs: [],
      selected: [],
      page: 0,
      pageSize: 6,
      search: false,
      searchForm: {}
    };
  }

  componentDidMount(){
    this._setAllStates(() => {
      this.GetClients();
    });
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(PAClientManageM.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  _onPageSizeChange = (pageSize) => {
    this.setState({
      pageSize: pageSize
    });
  }

  _onPageChange = (page) => {
    this.setState({
      page: page
    });
  }

  _Reload = () => {
    let {search} = this.state;
    if(search){
      this._toSearch();
    }else{
      this.GetClients();
    }
  }

  onMountQForm = (callbacks) => {
    this.MountQForm = callbacks;
  }

  onFormChange = (formValue) => {
    this.setState({
      searchForm: formValue
    });
  }

  GetClients = async () => {
    let res = await ReqX.SendBE("/Web/Agent/GetClients");
    let {Success, payload} = res;
    if(Success){
      this.setState({
        docs: payload
      });
    }
  }

  _toClearSearch = () => {
    this.setState({
      searchForm: {},
      search: false
    }, () => {
      this.MountQForm?.Clear();
      this._Reload();
    });
  }

  _toSearch = async () => {
    let {searchForm} = this.state;
    let res = await ReqX.SendBE("/Web/Agent/SearchClients", {
      searchForm
    });
    let {Success, payload} = res;
    if(Success){
      this.setState({
        search: true,
        docs: payload
      });
    }
  }

  _toNewClient = () => {
    GFunc.Backdrop(() => {
      return (
        <NewClient Refresh={this.GetClients}/>
      );
    }, {}, false);
  }

  _toPopupDetails = (_id) => {
    let {docs} = this.state;
    let doc = _.find(docs, o => o._id === _id);
    GFunc.Backdrop(() => {
      return (
        <ViewClient Refresh={this.GetClients} doc={doc}/>
      );
    }, {}, false);
  }

  renderHeader(){
    return (
      <HStack mB={24}>
        <XText bold color={ColorX.CSS("Leaf")} fontSize={16}>
          {LocaleX.Parse({
            EN: "Client Management",
            TC: "客戶管理"
          })}
        </XText>
        <Spacer/>
        <XButton onPress={this._toNewClient} pH={30} round={50}
            bgColor={ColorX.CSS("Axit")}
            color={ColorX.CSS("pureWhite")}
            padding={6}>
          <HStack>
            <XText bold fontSize={14}>
              {LocaleX.Parse({
                EN: "Add new client",
                TC: "新增客戶"
              })}
            </XText>
          </HStack>
        </XButton>
      </HStack>
    );
  }

  renderTextField(name, label, readOnly = false){
    let {userDoc} = this.state;
    let value = Accessor.Get(userDoc, name);
    return (
      <VStack fullWidth>
        <HStack HAlign="[" spacing={4}>
          <XText fontSize={12} color={ColorX.CSS("Stone")}>
            {LocaleX.Parse(label)}
          </XText>
        </HStack>
        <QFText name={name} placeholder={LocaleX.Parse({
          EN: "Search ",
          TC: "搜尋 "
        }) + LocaleX.Parse(label).toLowerCase()} disabled={readOnly}
          defaultValue={value}
          p={12}
          focus_bColor={ColorX.CSS("Axit")}
          bColor={ColorX.CSS("Gray5")}/>
      </VStack>
    );
  }

  renderSearchForm(){
    let {search, searchForm} = this.state;
    return (
      <QForm fullWidth p={16} bgColor={ColorX.CSS("pureWhite")}
        spacing={24} value={searchForm} onMounted={this.onMountQForm}
        onChange={this.onFormChange}>
        {this.renderTextField("customerName", 
          {
            EN: "Customer's name",
            TC: "顧客名稱"
          })}
          {this.renderTextField("email", 
          {
            EN: "Email",
            TC: "電郵"
          })}
        {this.renderTextField("telNo", 
          {
            EN: "Phone number",
            TC: "電話號碼"
          })}
        {this.renderTextField("HKID", 
          {
            EN: "HKID",
            TC: "身分證號碼"
          })}
        <HStack>
          <XButton onPress={this._toClearSearch} fullWidth
            color={ColorX.CSS("Axit")}>
            <HStack>
              <XText bold>
                {LocaleX.Parse({
                  EN: "Reset",
                  TC: "重置"
                })}
              </XText>
            </HStack>
          </XButton>
          <XButton onPress={this._toSearch} padding={0} pV={5} fullWidth
            color={ColorX.CSS(search ? "pureWhite" : "Axit")} 
            bgColor={ColorX.CSS(search ? "Axit" : "pureWhite")} 
            style={{borderColor: ColorX.CSS("Axit")}}
            bW={1} round={50}>
            <HStack>
              <XText bold>
                {LocaleX.Parse({
                  EN: "Search",
                  TC: "搜尋"
                })}
              </XText>
            </HStack>
          </XButton>
        </HStack>
      </QForm>
    );
  }

  renderClientDoc(doc, idx){
    let {_id, meta, email, telNo} = doc ?? {};
    let {fullName} = meta ?? {};
    telNo = ZString.Hide(telNo, 5);
    return (
      <VStack bgColor={ColorX.CSS("pureWhite")} fullWidth shadow round={3}
        p={16} spacing={10} key={idx} m={8}>
        <HStack HAlign="[">
          <XText color={ColorX.CSS("Leaf")} fontSize={14} bold>
            {LocaleX.Parse(fullName)}
          </XText>
        </HStack>
        <HStack>
          <HStack spacing={5} HAlign="[" fitWidthToContent>
            <XImage source={"/Images/Icons/cm_email.png"} width={25}/>
            <XText fontSize={12} color={ColorX.CSS("Gray3")}>
              {LocaleX.Parse({
                EN: "Email",
                TC: "電郵"
              })}
            </XText>
          </HStack>
          <HStack HAlign="]">
            <XText fontSize={14}>
              {email}
            </XText>
          </HStack>
        </HStack>
        <HStack>
          <HStack spacing={5} HAlign="[" fitWidthToContent>
            <XImage source={"/Images/Icons/cm_phone.png"} width={25}/>
            <XText fontSize={12} color={ColorX.CSS("Gray3")}>
              {LocaleX.Parse({
                EN: "Phone",
                TC: "電話"
              })}
            </XText>
          </HStack>
          <HStack spacing={5} HAlign="]">
            <XText fontSize={14}>
              {"+852"}
            </XText>
            <XText fontSize={14}>
              {telNo}
            </XText>
          </HStack>
        </HStack>
        <HStack HAlign="]">
          <XButton notInjectColor onPress={() => this._toPopupDetails(_id)} padding={0} pV={2}>
            <HStack>
              <XText fontSize={12} color={ColorX.CSS("Axit")} style={{textDecoration: "underline"}}>
                {LocaleX.Parse({
                  EN: "View Details",
                  TC: "顯示詳細資料"
                })}
              </XText>
            </HStack>
          </XButton>
        </HStack>
      </VStack>
    );
  }

  renderClientList(){
    let {docs, page, pageSize} = this.state;
    let _docs = _.slice(docs, page * pageSize, (page + 1) * pageSize);
    if(_docs.length === 0){
      return QUICKUI.NoDocs({
        EN: "No Client Records",
        TC: "沒有客戶紀錄。"
      });
    }
   return (
      <VStack fullWidth>
        {_.map(_docs, (o, i) => {
          return this.renderClientDoc(o, i);
        })}
        <PageFlipper totalDocs={docs.length} 
          page={page}
          pageSize={pageSize}
          pageSizeOptions={[6, 12, 18, 24]}
          onPageSizeChange={this._onPageSizeChange}
          onPageChange={this._onPageChange}
          popupPosition="top" 
          mainColor={ColorX.CSS("Axit")} 
          fontSize={12}         
          />
      </VStack>
    );
  }

  renderClientHeader(){
    return (
      <HStack spacing={20} HAlign="[">
        <XText bold>
          {LocaleX.Parse({
            EN: "List clients",
            TC: "客戶名單"
          })}
        </XText>
      </HStack>
    );
  }

  renderClients(){
    return (
      <VStack fullWidth mT={20} spacing={10}>
        {this.renderClientHeader()}
        {this.renderClientList()}
      </VStack>
    );
  }

  renderSearchText(){
    let {search, searchForm} = this.state;
    if(!search) return;
    let {customerName, email, telNo, HKID} = searchForm;
  
    let searches = [];
    if(customerName) searches.push(customerName);
    if(email) searches.push(email);
    if(telNo) searches.push(telNo);
    if(HKID) searches.push(HKID);

    let searchText = searches.join(" - ");

    return (
      <HStack HAlign="[" spacing={5} pV={10}>
        <XText color={ColorX.CSS("Stone")}>
          {LocaleX.Parse({
            EN: "Result for",
            TC: "搜索結果"
          })}
        </XText>
        <XText color={ColorX.CSS("Stone")} bold>
          {`"${searchText}"`}
        </XText>
      </HStack>
    );
  }

  render(){
    return (
      <PAContainer>
        <VStack bgColor={ColorX.CSS("NotQuiteWhite")} fullWidth
          p={16}>
            {this.renderHeader()}
            {this.renderSearchForm()}
            {this.renderSearchText()}
            {this.renderClients()}
        </VStack>
      </PAContainer>
    );
  }

}

export default observer(PAClientManageM);
